export enum AccountDetailsDrawerType {
  NewAccount = "NewAccount",
  EditExistingAccount = "EditExistingAccount",
}
